import React from 'react';

import { Toast } from 'antd-mobile';
import ProgressComponent from '../../components/progress';

import styles from './index.module.less';
import { getProtocolDetail } from '../../service/chat-service';
import tools from '../../utils/tools';

class Protocol extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      protocolObj: {},
      isEnd: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const productId = tools.getQueryString('productId') || null;

    getProtocolDetail(productId)
      .then((res) => {
        const { code, data, message } = res;
        if (code !== 10000) return Toast.show(message || '查询购买协议失败');
        this.setState({ protocolObj: data, isEnd: true });
        document.title = data.protocolName;
        return true;
      })
      .catch((err) => Toast.show(err.message || '查询购买协议失败'));
  };

  render() {
    const { protocolObj, isEnd } = this.state;

    return (
      <div className={styles.protocolBox}>
        <ProgressComponent loading={isEnd} />
        <div
          className={styles.protocol}
          dangerouslySetInnerHTML={{ __html: protocolObj.protocolContent }}
        />
      </div>
    );
  }
}

export default Protocol;
